// test602
(602 && 0);
